<template>
    <!--End category switcher-->
    <div>
        <ul class="categories">
            <li v-for="(category, index) in productCategories" v-bind:class="{active: category.slug === $route.params.slug || (justLoaded && index === 0)}">
                <router-link :to="urlPrefix + category.slug">
                    <span class="filter-icon" v-html="category.icon"></span>
                    <span>{{category.title}}</span>
                </router-link>
            </li>

        </ul>
    </div>
</template>

<script>
import helpers from './../../helpers'
export default {

    data: function() {
        return {
            helpers: helpers,
            slug: this.specialFilterSlug
        }
    },
    props: {
        'productCategories': {required: true},
        'specialFilterSlug': {required: true}

    },
    computed: {
        urlPrefix: function() {
            return '/' + helpers.getLocale() + '/' + this.slug + '/';
        },
        justLoaded: function(){
            return (this.$route.params.slug === undefined);
        }
    }
}
</script>
<style scss scoped>
    .active{
        background-color: #000000;
        color: #ffffff;
    }

    .filter-icon svg{
        height: 50px;
    }

    .categories li.active svg{
        fill: #fff;
    }

</style>



// WEBPACK FOOTER //
// resources/assets/js/site/components/temporary-bhf-filter/bhf-category-switcher.vue